import { useEffect, useRef, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import api from "../../utils/axios/api";
import { useCep } from "../../context/CepContext";
import { Produto } from "../../components/CardProduto/CardProduto";
import { CepProducts, ProductWithDistance } from "./types";

export function useProductSearch() {
  const [products, setProducts] = useState<ProductWithDistance[]>([]);
  const [pages, setPages] = useState(1);
  const requestIdRef = useRef(0);
  const { cep } = useCep();
  const { page } = useParams();
  const [paramQuery] = useSearchParams();

  const search = paramQuery.get("name");
  const categoriesSelected = paramQuery.get("categories");
  const brandsSelected = paramQuery.get("brands");
  const problemsSelected = paramQuery.get("problems");
  const stagesSelected = paramQuery.get("stage");
  const solutionsSelected = paramQuery.get("solutions");
  const subcategorySelected = paramQuery.get("subcategories");
  const filterSelected = paramQuery.get("filter");
  const minSelected = paramQuery.get("min");
  const maxSelected = paramQuery.get("max");
  const starSelected = paramQuery.get("star");

  useEffect(() => {
    async function changeQueryParam() {
      const requestId = ++requestIdRef.current;

      const categoriesString = categoriesSelected ? categoriesSelected.split(",").join("$") : "";
      const brandsString = brandsSelected ? brandsSelected.split(",").join("$") : "";
      const problemsString = problemsSelected ? problemsSelected.split(",").join("$") : "";
      const solutionsString = solutionsSelected ? solutionsSelected.split(",").join("$") : "";
      const stageString = stagesSelected ? stagesSelected.split(",").join("$") : "";
      const subcategoryString = subcategorySelected ? subcategorySelected.split(",").join("$") : "";
      const searchString = search ?? "";
      const filterString = filterSelected ?? "";
      const min = minSelected ? Number(minSelected) : 0;
      const max = maxSelected ? Number(maxSelected) : 0;

      try {
        const ratingParam = starSelected ? `&rating=${starSelected}` : "";
        if (cep) {
          const responseProducts = await api.post(
            `/geolocation/near-store-with-cep?cep=${cep.replace("-", "")}&categories=${categoriesString}&brands=${brandsString}&min=${min}&${max === 0 ? "" : `max=${max}&`}name=${searchString}&problems=${problemsString}&solutions=${solutionsString}&stage=${stageString}&subcategory=${subcategoryString}&page=${page}&${filterString ? `filter=${filterString}` : ""}${ratingParam}`
          );
          const aux: ProductWithDistance[] = responseProducts.data.stores
            .map((store: CepProducts) => {
              const { distance, storeName } = store;
              return store.products.map((product: Produto) => ({ ...product, distance, storeName }));
            })
            .flat();
          if (requestId !== requestIdRef.current) return;
          setProducts(aux);
          setPages(responseProducts.data.pages);
          window.scrollTo(0, 0);
          return;
        }
        const responseProducts = await api.get(
          `/product/filter?categories=${categoriesString}&brands=${brandsString}&min=${min}&${max === 0 ? "" : `max=${max}&`}name=${searchString}&problems=${problemsString}&solutions=${solutionsString}&stage=${stageString}&subcategory=${subcategoryString}&page=${page}&${filterString ? `filter=${filterString}` : ""}${ratingParam}`
        );
        if (requestId !== requestIdRef.current) return;
        setProducts(responseProducts.data.products);
        setPages(responseProducts.data.pages);
        window.scrollTo(0, 0);
      } catch (error) {
        setProducts([]);
        console.log(error);
      }
    }

    if (!cep || cep.replace("-", "").length === 8) changeQueryParam();
  }, [page, search, categoriesSelected, brandsSelected, problemsSelected, stagesSelected, solutionsSelected, subcategorySelected, minSelected, maxSelected, starSelected, filterSelected, cep]);

  return { products, pages };
}
